import Loadable from '../../components/loadable';

const SmsDeliveriesReport = Loadable({
  loader: () => import('../../pages/reports/sms_deliveries_report'),
});

angular.module('gym').value('SmsDeliveriesReport', SmsDeliveriesReport);
